/**
 * Panel sửa thông tin riêng tư khách hàng — chọn thẻ rồi cập nhật form bên phải.
 */
import { ButtonSpinner } from '../Common/ButtonSpinner';

export const AdminManagedUserEditPanel = ({
  labels,
  common,
  selectedUser,
  privateForm,
  cccdError,
  isSaving,
  onFieldChange,
  onSubmit,
}) => (
  <aside className="admin-users-create-panel admin-managed-user-edit-panel">
    {selectedUser ? (
      <form className="admin-users-create-form" onSubmit={onSubmit}>
        <div className="admin-users-create-head">
          <span className="admin-users-create-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none">
              <path
                d="M12 12a4 4 0 100-8 4 4 0 000 8zM5.5 19c0-3.038 2.91-5.5 6.5-5.5s6.5 2.462 6.5 5.5"
                stroke="currentColor"
                strokeWidth="1.75"
                strokeLinecap="round"
              />
            </svg>
          </span>
          <div>
            <h2>{labels.editTitle}</h2>
            <p>{labels.editHint}</p>
          </div>
        </div>

        <div className="admin-managed-user-selected">
          <strong>{selectedUser.name}</strong>
          <span>{selectedUser.email}</span>
          <span>{selectedUser.phone || common.noPhone}</span>
        </div>

        <div className="admin-users-private-section">
          <div className="admin-users-private-head">
            <strong>{labels.privateSectionTitle}</strong>
            <span>{labels.privateSectionHint}</span>
          </div>
          <div className="admin-users-create-fields">
            <label>
              {labels.residentialAddress}
              <input
                value={privateForm.residential_address}
                onChange={(event) => onFieldChange('residential_address', event.target.value)}
              />
            </label>
            <label>
              {labels.hometown}
              <input
                value={privateForm.hometown}
                onChange={(event) => onFieldChange('hometown', event.target.value)}
              />
            </label>
            <label>
              {labels.residence}
              <input
                value={privateForm.residence}
                onChange={(event) => onFieldChange('residence', event.target.value)}
              />
            </label>
            <label>
              {labels.age}
              <input
                type="number"
                min="18"
                max="100"
                value={privateForm.age}
                onChange={(event) => onFieldChange('age', event.target.value)}
              />
            </label>
            <label>
              {labels.cccd}
              <input
                inputMode="numeric"
                value={privateForm.cccd}
                maxLength={12}
                onChange={(event) => onFieldChange('cccd', event.target.value.replace(/\D/g, ''))}
              />
              {cccdError && <span className="field-hint field-hint--error">{cccdError}</span>}
            </label>
          </div>
        </div>

        <button className="button full-width" disabled={isSaving}>
          {isSaving && <ButtonSpinner />}
          {isSaving ? common.saving : labels.saveButton}
        </button>
      </form>
    ) : (
      <div className="admin-managed-user-edit-empty">
        <strong>{labels.emptySelectionTitle}</strong>
        <p>{labels.emptySelectionMessage}</p>
      </div>
    )}
  </aside>
);
